<script lang="ts">
	import { getPostTradeDetails } from '$lib/data/userInteract';
	import { MIN_DEPOSIT_AMOUNT } from '$lib/settings';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import { addDollarSign, debounce, getNumBackInUnits, sanitizeInputs, toBN } from '$lib/util/util';
	import BigNumber from 'bignumber.js';
	import { currentMarketAsset } from '../store';
	import { onDestroy } from 'svelte';
	import { executingOrder, isAddMaxMargin, margin, marginInputForTrade } from './store';

	export let marginInput: string;
	export let isMarginInputAmountGTMax: boolean;
	function onInputChange() {
		isAddMaxMargin.set(false);
		marginInput = sanitizeInputs(marginInput);
		if (marginInput) marginInputForTrade.set(toBN(marginInput).toString());
		else marginInputForTrade.set('0');
	}

	$: placeholder = new BigNumber($margin).gte(new BigNumber($MIN_DEPOSIT_AMOUNT).multipliedBy(1e18))
		? '0 (optional)'
		: '0';

	const currentMarketAssetEventListener = currentMarketAsset.subscribe((value) => {
		if (value) {
			marginInput = '';
			$marginInputForTrade = '0';
		}
	});

	onDestroy(() => {
		currentMarketAssetEventListener();
	});
</script>

<div
	class="flex justify-between items-center w-full border border-fx-grey-500 bg-fx-gradient-8 rounded-lg squircle-lg py-2 px-3 mt-4"
	class:border-fx-red={isMarginInputAmountGTMax && !$isAddMaxMargin}
>
	<input
		inputmode="decimal"
		autocomplete="off"
		autocorrect="off"
		pattern="^[0-9]*[.,]?[0-9]*$"
		minlength="1"
		maxlength="79"
		spellcheck="false"
		type="string"
		{placeholder}
		data-testid="open-position-amount"
		class="bg-transparent text-fx-white font-medium outline-none text-sm"
		bind:value={marginInput}
		on:input={onInputChange}
		use:debounce={{ marginInput, func: getPostTradeDetails, duration: 300 }}
	/>

	<div class="text-fx-grey-200 text-xs flex gap-2">
		<Tooltip header="Add Margin" title="Add this to increase your total margin: Min. $50.">
			<div class="text-fx-grey-400 border-r border-fx-grey-400 pr-2 pt-px">Margin</div>
		</Tooltip>
		<div class="px-1 py-0.5 rounded-sm cursor-pointer">USD</div>
	</div>
</div>
